<template>
    <div class="panel">
        <div class="groundwater-flow">
            <CircleImage
                title="Groundwater Flow"
                image="https://picsum.photos/seed/north/150/150"
                :text="siteDetails.directionOfGroundWaterFlow"
            />
        </div>
        <div class="info">
            <h3 class="title">
                Water Table Depth
            </h3>
            <p class="text">
                {{ siteDetails.waterTableDepth }}
            </p>
            <h3 class="title">
                Thickness of NAPL<br>(Non-Aqueous Phase Liquids)
            </h3>
            <p class="text">
                {{ siteDetails.thicknessOfNonAqueousPhaseLiquids }}
            </p>
        </div>
        <div class="fine-soil-grain">
            <CircleImage
                title="Fine Soil Grain"
                image="https://picsum.photos/seed/soil/150/150"
                :text="siteDetails.isFine"
                :is-disabled="siteDetails.isFine =='No'"
            />
        </div>
        <div class="coarse-soil-grain">
            <CircleImage
                title="Coarse Soil Grain"
                image="https://picsum.photos/seed/grain/150/150"
                :text="siteDetails.isCoarse"
                :is-disabled="siteDetails.isCoarse =='No'"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ESARSite from '@/models/ESARSite';

import CircleImage from '../CircleImage/CircleImage.vue';

export default defineComponent({
    name: 'GroundwaterAndSoilGrainSize',
    components: {
        CircleImage
    },
    props: {
        siteDetails: ESARSite
    },
    setup() {}
});
</script>

<style lang="postcss" scoped>
.panel {
    @apply flex;

    .groundwater-flow,
    .fine-soil-grain,
    .coarse-soil-grain,
    .info {
        @apply w-1/5 text-left;
    }

    .info {
        @apply w-2/5;

        .title {
            @apply mb-0;
        }

        .text {
            @apply mb-4;
        }
    }

    .title {
        @apply font-bold capitalize mb-4;
    }
}
</style>
